export default (function (siteVars) {
    return {
        backgroundColor: siteVars.gray10,
        backgroundColorMine: '#3B3C54',
        color: siteVars.white,
        contentFocusOutlineColor: siteVars.brand,
    };
});
